import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BackdropLoader, Icon } from '@livable/saas-react-components';
import { Button, Typography, Checkbox, MenuItem, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { arrayHaveSameStrings } from 'src/utils/arrayHelpers';
import { CreateEditPortfolioModal } from 'src/components/shared/CreateEditPortfolioModal';
export const GetForm = observer(_ref => {
  var _store$homeDashboardS5, _store$homeDashboardS6;
  let callback = _ref.callback,
    externalPortfolioListIds = _ref.externalPortfolioListIds;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const _useState = useState(externalPortfolioListIds !== null && externalPortfolioListIds !== void 0 ? externalPortfolioListIds : []),
    _useState2 = _slicedToArray(_useState, 2),
    selectedPortfolioIds = _useState2[0],
    setSelectedPortfolioIds = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchKey = _useState4[0],
    setSearchKey = _useState4[1];
  const getIsLoading = () => {
    var _store$buildings$getB, _store$properties$get;
    return store.portfolios.getExistingPortfoliosAsync.inProgress || store.portfolios.getPortfoliosDashboardAsync.inProgress || store.portfolios.transferPortfoliosAsync.inProgress || ((_store$buildings$getB = store.buildings.getBuildingsBatchAsync) === null || _store$buildings$getB === void 0 ? void 0 : _store$buildings$getB.inProgress) || ((_store$properties$get = store.properties.getPropertiesBatchAsync) === null || _store$properties$get === void 0 ? void 0 : _store$properties$get.inProgress);
  };
  const getIsConfirmDisabled = () => {
    return selectedPortfolioIds.length === 0;
  };
  const confirmMoving = async event => {
    event.stopPropagation();
    event.preventDefault();
    callback({
      action: 'submit',
      data: {
        portfolioIds: selectedPortfolioIds
      }
    });
  };
  return /*#__PURE__*/React.createElement("form", {
    className: classes.form
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.commonPadding
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.xsSection, " ").concat(classes.formTitle)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('portfolios_properties_page.select_existing_portfolio')), /*#__PURE__*/React.createElement(CreateEditPortfolioModal, {
    triggerRefresh: payload => {
      var _store$homeDashboardS;
      if (payload && payload !== null && payload !== void 0 && payload.createdPortfolioId) {
        callback({
          action: 'submit',
          data: {
            portfolioIds: [...selectedPortfolioIds, payload === null || payload === void 0 ? void 0 : payload.createdPortfolioId]
          }
        });
      }
      (_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 || _store$homeDashboardS.fetchCompanyPortfoliosData({});
    },
    customTrigger: /*#__PURE__*/React.createElement(Button, {
      variant: "actionIcon",
      id: "create-new-portfolio-button",
      'custom-attribute': '340-AssignPortfoliosToPropertyModal-create-new-portfolio-button'
    }, /*#__PURE__*/React.createElement("span", {
      className: "actionText"
    }, t('portfolios_properties_page.new_portfolio')))
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "search-team-member",
    name: "search-team-member",
    label: t('portfolios_properties_page.search_for_portfolio'),
    variant: "outlined",
    value: searchKey,
    onChange: event => {
      setSearchKey(event.target.value);
    },
    fullWidth: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.xsSection, " ").concat(classes.portfoliosRadioGroupWrapper)
  }, /*#__PURE__*/React.createElement(MenuItem, {
    key: 'portfoliosRadioGroupSelectAll_key',
    value: 'portfoliosRadioGroupSelectAll_id',
    variant: "multiple",
    className: "".concat(classes.portfoliosRadioGroup, " ").concat(classes.portfoliosRadioGroupSelectAll),
    onClick: event => {
      var _store$homeDashboardS2;
      event.stopPropagation();
      event.preventDefault();
      if (arrayHaveSameStrings((_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.companyPortfoliosList) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.map(i => i.id), selectedPortfolioIds)) {
        var _store$homeDashboardS3;
        setSelectedPortfolioIds([...((_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS3 === void 0 || (_store$homeDashboardS3 = _store$homeDashboardS3.companyPortfoliosList) === null || _store$homeDashboardS3 === void 0 || (_store$homeDashboardS3 = _store$homeDashboardS3.filter(i => i.isDefault)) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.map(i => i.id))]);
      } else {
        var _store$homeDashboardS4;
        setSelectedPortfolioIds((_store$homeDashboardS4 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.companyPortfoliosList) === null || _store$homeDashboardS4 === void 0 ? void 0 : _store$homeDashboardS4.map(i => i.id));
      }
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: arrayHaveSameStrings((_store$homeDashboardS5 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS5 === void 0 || (_store$homeDashboardS5 = _store$homeDashboardS5.companyPortfoliosList) === null || _store$homeDashboardS5 === void 0 ? void 0 : _store$homeDashboardS5.map(i => i.id), selectedPortfolioIds)
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('Select all'))), (_store$homeDashboardS6 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS6 === void 0 || (_store$homeDashboardS6 = _store$homeDashboardS6.companyPortfoliosList) === null || _store$homeDashboardS6 === void 0 ? void 0 : _store$homeDashboardS6.slice().sort((a, b) => {
    var _ref2;
    return (_ref2 = '' + (a === null || a === void 0 ? void 0 : a.name)) === null || _ref2 === void 0 ? void 0 : _ref2.localeCompare(b === null || b === void 0 ? void 0 : b.name, undefined, {
      numeric: true
    });
  }).sort((a, b) => {
    if (a.isDefault === b.isDefault) return 0;
    return a.isDefault ? -1 : 1;
  }).filter(i => {
    if (!(store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin || store.account.userProfile.isUserPropertyManagerAccountHolder)) {
      return !i.isDefault;
    } else {
      return true;
    }
  }).filter(portfolio => {
    const searchPhrase = new RegExp(searchKey, 'gi');
    return searchKey.length > 0 ? " ".concat(portfolio.name).search(searchPhrase) > 0 : true;
  }).map(item => /*#__PURE__*/React.createElement(MenuItem, {
    key: item.id,
    value: item.id,
    variant: "multiple",
    className: classes.portfoliosRadioGroup,
    selected: selectedPortfolioIds.includes(item.id),
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
      if (item.isDefault) return;
      if (selectedPortfolioIds.includes(item.id)) {
        setSelectedPortfolioIds(selectedPortfolioIds.filter(id => id !== item.id));
      } else {
        setSelectedPortfolioIds([...selectedPortfolioIds, item.id]);
      }
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: selectedPortfolioIds.includes(item.id),
    disabled: item.isDefault,
    onChange: () => {
      if (item.isDefault) return;
      if (selectedPortfolioIds.includes(item.id)) {
        setSelectedPortfolioIds(selectedPortfolioIds.filter(id => id !== item.id));
      } else {
        setSelectedPortfolioIds([...selectedPortfolioIds, item.id]);
      }
    }
  }), /*#__PURE__*/React.createElement(Icon, {
    type: "folder-house"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body"
  }, item.name))))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: () => {
      callback({
        action: 'cancel'
      });
    },
    'custom-attribute': '673-new-billing-module-AssignPortfoliosToPropertyModal'
  }, t('buttons.cancel')))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    onClick: event => confirmMoving(event),
    disabled: getIsLoading() || getIsConfirmDisabled(),
    'custom-attribute': '674-new-billing-module-AssignPortfoliosToPropertyModal'
  }, t('buttons.save')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: getIsLoading()
  }));
});